import { useQuery } from "@tanstack/react-query"

import { useStableFunction } from "@repo/ui/hooks/use-stable-function"
import { requireUser } from "../require-user"
import type { AuthUser } from "../utils"
import { useSupabase } from "./use-supabase"

export const queryKey = ["auth", "user"]

export type UseUserProps = {
  initialData?: AuthUser | null
}

export function useUser({ initialData }: UseUserProps = {}) {
  const supabase = useSupabase()

  const queryFn = useStableFunction(async () => {
    const { user, error } = await requireUser(supabase)

    if (error || !user) {
      return null
    }

    return user
  })

  return useQuery({
    queryFn,
    queryKey,
    initialData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}
